import flatten from 'lodash/flatten';
import { ContextMenuOption } from '@y42/canvas-components';
import { contextMenuConfig, nodeType } from '../../../config/config';
import { alignNodesInGroupAPI } from './align-nodes-in-group-api';
import { backgroundColorAPI } from './background-color-api';
import { BasePropertyApi } from './base-api.interface';
import { borderColorAPI } from './border-color.api';
import { borderStyleAPI } from './border-style-api';
import { deleteAPI } from './delete-api';
import { fontFamilyAPI } from './font-family.api';
import { fontSizeAPI } from './font-size.api';
import { fontWeightAPI } from './font-weight.api';
import { lockedAPI } from './locked-api';
import { shadowAPI } from './shadow-api';
import { textAlignmentAPI } from './text-alignment.api';
import { textColorAPI } from './text-color.api';
import { textHighlightColorAPI } from './text-highlight.api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const apiMap: Partial<Record<ContextMenuOption, BasePropertyApi | ((group: go.Node) => void)>> = {
  fontFamily: fontFamilyAPI,
  fontSize: fontSizeAPI,
  fontWeight: fontWeightAPI,
  textAlignment: textAlignmentAPI,
  shapeColor: backgroundColorAPI,
  shapeBorder: borderColorAPI,
  lineColor: borderColorAPI,
  borderStyle: borderStyleAPI,
  lineStyle: borderStyleAPI,
  textColor: textColorAPI,
  textHighlight: textHighlightColorAPI,
  shadow: shadowAPI,
  lock: lockedAPI,
  alignNodes: alignNodesInGroupAPI,
  delete: deleteAPI,
};

export const getApiForNodeType = (type: nodeType) =>
  flatten(contextMenuConfig[type]).reduce((acc, val) => (apiMap[val] ? { ...acc, [val]: apiMap[val] } : acc), {});
